{
  "name": "205ed2 (TonalPlexus)",
  "description": "Octave divided into 205 equal steps in a layout similar to the Tonal Plexus multichannel MIDI controller, which uses five cycles of 41ed2 to closely approximate many harmonic relationships. Note names are the MIDI note numbers on channel pairs a/b mapped to a single 205ed2 block. The Tonal Plexus has 6 blocks, using Channels 3-4, 5-6, 7-8, 9-10. 11-12, 13-14. Note 7 on Ch 9 is mapped to hexatone central degree.",
  "scale": [
    "5.9",
    "11.7",
    "17.6",
    "23.4",
    "29.3",
    "35.1",
    "41.0",
    "46.8",
    "52.7",
    "58.5",
    "64.4",
    "70.2",
    "76.1",
    "82.0",
    "87.8",
    "93.7",
    "99.5",
    "105.4",
    "111.2",
    "117.1",
    "122.9",
    "128.8",
    "134.6",
    "140.5",
    "146.3",
    "152.2",
    "158.0",
    "163.9",
    "169.8",
    "175.6",
    "181.5",
    "187.3",
    "193.2",
    "199.0",
    "204.9",
    "210.7",
    "216.6",
    "222.4",
    "228.3",
    "234.1",
    "240.0",
    "245.9",
    "251.7",
    "257.6",
    "263.4",
    "269.3",
    "275.1",
    "281.0",
    "286.8",
    "292.7",
    "298.5",
    "304.4",
    "310.2",
    "316.1",
    "322.0",
    "327.8",
    "333.7",
    "339.5",
    "345.4",
    "351.2",
    "357.1",
    "362.9",
    "368.8",
    "374.6",
    "380.5",
    "386.3",
    "392.2",
    "398.0",
    "403.9",
    "409.8",
    "415.6",
    "421.5",
    "427.3",
    "433.2",
    "439.0",
    "444.9",
    "450.7",
    "456.6",
    "462.4",
    "468.3",
    "474.1",
    "480.0",
    "485.9",
    "491.7",
    "497.6",
    "503.4",
    "509.3",
    "515.1",
    "521.0",
    "526.8",
    "532.7",
    "538.5",
    "544.4",
    "550.2",
    "556.1",
    "562.0",
    "567.8",
    "573.7",
    "579.5",
    "585.4",
    "591.2",
    "597.1",
    "602.9",
    "608.8",
    "614.6",
    "620.5",
    "626.3",
    "632.2",
    "638.0",
    "643.9",
    "649.8",
    "655.6",
    "661.5",
    "667.3",
    "673.2",
    "679.0",
    "684.9",
    "690.7",
    "696.6",
    "702.4",
    "708.3",
    "714.1",
    "720.0",
    "725.9",
    "731.7",
    "737.6",
    "743.4",
    "749.3",
    "755.1",
    "761.0",
    "766.8",
    "772.7",
    "778.5",
    "784.4",
    "790.2",
    "796.1",
    "802.0",
    "807.8",
    "813.7",
    "819.5",
    "825.4",
    "831.2",
    "837.1",
    "842.9",
    "848.8",
    "854.6",
    "860.5",
    "866.3",
    "872.2",
    "878.0",
    "883.9",
    "889.8",
    "895.6",
    "901.5",
    "907.3",
    "913.2",
    "919.0",
    "924.9",
    "930.7",
    "936.6",
    "942.4",
    "948.3",
    "954.1",
    "960.0",
    "965.9",
    "971.7",
    "977.6",
    "983.4",
    "989.3",
    "995.1",
    "1001.0",
    "1006.8",
    "1012.7",
    "1018.5",
    "1024.4",
    "1030.2",
    "1036.1",
    "1042.0",
    "1047.8",
    "1053.7",
    "1059.5",
    "1065.4",
    "1071.2",
    "1077.1",
    "1082.9",
    "1088.8",
    "1094.6",
    "1100.5",
    "1106.3",
    "1112.2",
    "1118.0",
    "1123.9",
    "1129.8",
    "1135.6",
    "1141.5",
    "1147.3",
    "1153.2",
    "1159.0",
    "1164.9",
    "1170.7",
    "1176.6",
    "1182.4",
    "1188.3",
    "1194.1",
    "1200.0"
  ],
  "key_colors_mode": "manual",
  "short_description": "OddPartialPC-47L",
  "built_in_group": "Equal Divisions",
  "key_labels": "note_names",
  "fundamental_color": "#ffdbe8",
  "note_names": [
    "a7",
    "a8",
    "a9",
    "a10",
    "a11",
    "a12",
    "a13",
    "a14",
    "a15",
    "a16",
    "a17-18",
    "a19",
    "a20",
    "a21",
    "a22",
    "a23",
    "a24",
    "a25",
    "a26",
    "a27",
    "a28",
    "a29",
    "a30",
    "a31",
    "a32",
    "a33",
    "a34",
    "a35",
    "a36",
    "a37",
    "a38",
    "a39",
    "a40",
    "a41",
    "a42",
    "a43",
    "a44",
    "a45",
    "a46",
    "a47",
    "a48",
    "a49",
    "a50",
    "a51",
    "a52",
    "a53",
    "a54",
    "a55",
    "a56",
    "a57",
    "a58",
    "a59",
    "a60",
    "a61",
    "a62",
    "a63",
    "a64",
    "a65",
    "a66",
    "a67",
    "a68-69",
    "a70",
    "a71",
    "a72",
    "a73",
    "a74",
    "a75",
    "a76",
    "a77",
    "a78",
    "a79",
    "a80",
    "a81",
    "a82",
    "a83",
    "a84",
    "a85",
    "a86",
    "a87",
    "a88",
    "a89",
    "a90",
    "a91",
    "a92",
    "a93",
    "a94",
    "a95",
    "a96",
    "a97",
    "a98",
    "a99",
    "a100",
    "a101",
    "a102",
    "a103",
    "a104-b0",
    "b1",
    "b2",
    "b3",
    "b4",
    "b5",
    "b6",
    "b7",
    "b8",
    "b9",
    "b10",
    "b11",
    "b12",
    "b13",
    "b14",
    "b15",
    "b16",
    "b17",
    "b18",
    "b19",
    "b20",
    "b21",
    "b22",
    "b23",
    "b24",
    "b25",
    "b26",
    "b27",
    "b28",
    "b29",
    "b30",
    "b31",
    "b32",
    "b33",
    "b34",
    "b35-36",
    "b37",
    "b38",
    "b39",
    "b40",
    "b41",
    "b42",
    "b43",
    "b44",
    "b45",
    "b46",
    "b47",
    "b48",
    "b49",
    "b50",
    "b51-52",
    "b53",
    "b54",
    "b55",
    "b56",
    "b57",
    "b58",
    "b59",
    "b60",
    "b61",
    "b62",
    "b63",
    "b64",
    "b65",
    "b66",
    "b67",
    "b68",
    "b69",
    "b70",
    "b71",
    "b72",
    "b73",
    "b74",
    "b75",
    "b76",
    "b77",
    "b78",
    "b79",
    "b80",
    "b81",
    "b82",
    "b83",
    "b84",
    "b85",
    "b86",
    "b87-88",
    "b89",
    "b90",
    "b91",
    "b92",
    "b93",
    "b94",
    "b95",
    "b96",
    "b97",
    "b98",
    "b99",
    "b100",
    "b101",
    "b102",
    "b103",
    "b104",
    "b105",
    "a0",
    "a1",
    "a2",
    "a3",
    "a4",
    "a5",
    "a6"
  ],
  "note_colors": [
    "#ffe0e0",
    "#ffffff",
    "#ffffff",
    "#bfbfbf",
    "#bfbfbf",
    "#bfbfbf",
    "#bfbfbf",
    "#bfbfbf",
    "#6db7fd",
    "#6db7fd",
    "#6db7fd",
    "#6db7fd",
    "#6db7fd",
    "#443f3c",
    "#443f3c",
    "#443f3c",
    "#443f3c",
    "#443f3c",
    "#342772",
    "#342772",
    "#342772",
    "#1d115a",
    "#1d115a",
    "#ccdbd7",
    "#ccdbd7",
    "#ccdbd7",
    "#ccdbd7",
    "#ccdbd7",
    "#dddada",
    "#dddada",
    "#dddada",
    "#dddada",
    "#dddada",
    "#ffffff",
    "#ffffff",
    "#ffffff",
    "#ffffff",
    "#ffffff",
    "#ccdbd7",
    "#ccdbd7",
    "#ccdbd7",
    "#ccdbd7",
    "#ccdbd7",
    "#dddada",
    "#dddada",
    "#dddada",
    "#dddada",
    "#dddada",
    "#443f3c",
    "#443f3c",
    "#443f3c",
    "#443f3c",
    "#443f3c",
    "#342772",
    "#342772",
    "#342772",
    "#342772",
    "#342772",
    "#6db7fd",
    "#6db7fd",
    "#6db7fd",
    "#6db7fd",
    "#6db7fd",
    "#bfbfbf",
    "#bfbfbf",
    "#bfbfbf",
    "#bfbfbf",
    "#bfbfbf",
    "#ffffff",
    "#ffffff",
    "#ffffff",
    "#ffffff",
    "#ffffff",
    "#ccdbd7",
    "#ccdbd7",
    "#ccdbd7",
    "#ccdbd7",
    "#ccdbd7",
    "#dddada",
    "#dddada",
    "#dddada",
    "#dddada",
    "#dddada",
    "#ffffff",
    "#ffffff",
    "#ffffff",
    "#ffffff",
    "#ffffff",
    "#bfbfbf",
    "#bfbfbf",
    "#bfbfbf",
    "#bfbfbf",
    "#bfbfbf",
    "#6db7fd",
    "#6db7fd",
    "#6db7fd",
    "#6db7fd",
    "#6db7fd",
    "#443f3c",
    "#443f3c",
    "#443f3c",
    "#443f3c",
    "#443f3c",
    "#342772",
    "#342772",
    "#342772",
    "#342772",
    "#342772",
    "#ccdbd7",
    "#ccdbd7",
    "#ccdbd7",
    "#ccdbd7",
    "#ccdbd7",
    "#dddada",
    "#dddada",
    "#dddada",
    "#dddada",
    "#dddada",
    "#ffffff",
    "#ffffff",
    "#ffffff",
    "#ffffff",
    "#ffffff",
    "#ccdbd7",
    "#ccdbd7",
    "#ccdbd7",
    "#ccdbd7",
    "#ccdbd7",
    "#6db7fd",
    "#6db7fd",
    "#6db7fd",
    "#6db7fd",
    "#6db7fd",
    "#443f3c",
    "#443f3c",
    "#443f3c",
    "#443f3c",
    "#443f3c",
    "#342772",
    "#342772",
    "#342772",
    "#342772",
    "#342772",
    "#6db7fd",
    "#6db7fd",
    "#6db7fd",
    "#6db7fd",
    "#6db7fd",
    "#dddada",
    "#dddada",
    "#dddada",
    "#dddada",
    "#dddada",
    "#ffffff",
    "#ffffff",
    "#ffffff",
    "#ffffff",
    "#ffffff",
    "#ccdbd7",
    "#ccdbd7",
    "#ccdbd7",
    "#ccdbd7",
    "#ccdbd7",
    "#dddada",
    "#dddada",
    "#dddada",
    "#dddada",
    "#dddada",
    "#443f3c",
    "#443f3c",
    "#443f3c",
    "#443f3c",
    "#443f3c",
    "#342772",
    "#342772",
    "#342772",
    "#342772",
    "#342772",
    "#6db7fd",
    "#6db7fd",
    "#6db7fd",
    "#6db7fd",
    "#6db7fd",
    "#bfbfbf",
    "#bfbfbf",
    "#bfbfbf",
    "#bfbfbf",
    "#bfbfbf",
    "#ffffff",
    "#ffffff",
    "#ffffff",
    "#ffffff",
    "#ffffff",
    "#ccdbd7",
    "#ccdbd7",
    "#ccdbd7",
    "#ccdbd7",
    "#ccdbd7",
    "#dddada",
    "#dddada",
    "#dddada",
    "#dddada",
    "#dddada",
    "#ffffff",
    "#ffffff"
  ],
  "equivSteps": 205,
  "fundamental": 260.740741,
  "reference_degree": 0,
  "center_degree": 0,
  "rSteps": 18,
  "drSteps": 17,
  "hexSize": 32,
  "rotation": -30
}
